import React from "react";
import { kinetik_api_url} from "~/app/utilities";
import axios from 'axios';
import _ from 'underscore';
import {addViewEra} from '../actions';
import jsPDF from 'jspdf';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MDSpinner from "react-md-spinner";
import CsvExport from "csvexport";


 


class ERA extends React.Component {
  constructor(props){
    super(props);
    this.state={
      showSpinner: false
    }
  }

  componentWillMount = () => {
    const provider_npi = localStorage.getItem('bill_npi');
    const token = localStorage.getItem('authToken');
    axios
      .get(kinetik_api_url + "/era/latestera/"+provider_npi+'?token='+token)
      .then(response => {
        this.props.addViewEra(response.data.data);
      })
      .catch(err => {
        console.log("/era/latestera error:", err);
      });
  };

  //if base64 img field is already set in the DB, just convert to pdf and download, else get from claimmd
  downloadERA=(eraid,index)=>{
    this.setState({showSpinner:true});
    //const eraArr= this.props.view_era
   // if(eraArr[index].base64Img.length===0){
      this.getPDF(eraid)
    // }else{
    //   // If base64 data is already in the ERA
    //   var pdf = new jsPDF();
    //   var width = pdf.internal.pageSize.width;    
    //   var height = pdf.internal.pageSize.height;
    //   const base64Images=eraArr[index].base64Img;
    //   let promise= Promise.resolve();
    //   _.each(base64Images,(encodedImg,index)=>{
    //     promise=promise.then(()=>{
    //       var myImage = 'data:image/jpeg;base64,'+encodedImg;
    //       pdf.addImage(myImage, 'jpeg', 0, 0,width,height-25);
    //       if(index<base64Images.length-1) pdf.addPage();
    //     })
    //   })

    //   promise=promise.then(()=>{
    //     this.setState({showSpinner:false})
    //     pdf.save(eraid+".pdf");
    //   })
    // }
  }

  //sending request to backend api to get pdf from claim md
  getPDF=(eraid)=>{
    const token = localStorage.getItem('authToken');
    axios.post(kinetik_api_url+"/era/pdf",{eraid:eraid,token}).then((res)=>{
      const base64Strings = res.data.data;
      var pdf = new jsPDF();
      var width = pdf.internal.pageSize.width;    
      var height = pdf.internal.pageSize.height;
      let promise= Promise.resolve();
      _.each(base64Strings,(encodedImg,index)=>{
        promise=promise.then(()=>{
          var myImage = 'data:image/jpeg;base64,'+encodedImg;
          pdf.addImage(myImage, 'jpeg', 0, 0,width,height-25);
          if(index<base64Strings.length-1) pdf.addPage();
        })
      })
      promise=promise.then(()=>{
        this.setState({showSpinner:false})
        pdf.save(eraid+".pdf");
      })
 })
}
exportCSV=(eraID)=>{
  const token = localStorage.getItem("authToken");
  let URL = kinetik_api_url + '/era/csv/' + eraID + "?token=" + token;
  axios.get(URL).then(res=>{
    console.log("keys", Object.keys(res.data.data[0]))
      const exporter = CsvExport.create({ filename: "export.csv", columns: Object.keys(res.data.data[0]) })
      exporter.downloadCsv(res.data.data);
    
  }).catch(err=>{
    console.log("era export to csv err:",err)
  })
}


  renderERAs = () => {
    const eraArr = this.props.view_era;
    if(eraArr===null){
      return(<div></div>)
    }else{
      return _.map(eraArr,(era,index)=>{
        return (
            <div key={index} className="era-item">
              <p>{era.payerID}</p>
              <p>{era.checkNumber}</p>
              <p>{era.paidAmount}</p>
              <p>{era.paidDate}</p>
              {/* <FontAwesome
                //className="icon-download"
                name="fas fa-download"
                onClick={() => this.downloadERA(era.eraID,index)}
              />
              <FontAwesome
                //className="fas fa-file-download"
                name="fas fa-file-download"
                onClick={()=>this.exportCSV(era.eraID)}
              /> */}
              <button className="era-download" onClick={() => this.downloadERA(era.eraID,index)}>
              PDF
              </button>
              <button className="era-download" onClick={()=>this.exportCSV(era.eraID)}>
              CSV
              </button>
            
            </div>
        );
      })
    }
  };

  render() {
    return (
      <div>
        <div className="era-header">
          <p>Payer</p>
          <p>Check Number</p>
          <p>Check Amount</p>
          <p>Paid Date</p>
          <div className="era-header-space"></div>
          {this.state.showSpinner&&<MDSpinner/>}
        </div>
        {this.renderERAs()}
      </div>
    );
  }
 

}
const mapStateToProps = state => {
  return {
    view_era:state.era.view_era,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addViewEra: addViewEra,
    },
    dispatch
  );
}

export default connect(mapStateToProps,mapDispatchToProps)(ERA);;



// WEBPACK FOOTER //
// ./src/app/era/era_view/ERA.js